/** @jsx h */
import { h } from 'preact'

import Profile from './Profile'
import StoryButtonList from './stories/StoryButtonList'
import t from '../../../utils/translate'

const HowAchievedSection = ({ initiatives, children, issuer, journeys, onStoryClick, name, analyticsContext }) => {
  if (initiatives.length === 0 && !children && journeys.length === 0) return null

  let initiativesTitle = null
  let initiativesList = null
  if (initiatives.length > 0) {
    initiativesTitle = (
      <h3 class='ModalCard-heading'>
        {t('proof_points.js.claims.how_achieved')}
      </h3>
    )

    initiativesList = (
      <ul class='ModalCard-list'>
        {initiatives.map(initiative => (
          <li class='ModalCard-listItem' key={initiative}>
            {initiative}
          </li>
        ))}
      </ul>
    )
  }

  let issuerDetails = null
  if (issuer) {
    issuerDetails = <Profile profile={issuer} />
  }

  return (
    <section class='ModalCard-section ModalCard-section--ugc'>
      {children}
      <div class='u-marginTop16'>
        <StoryButtonList
          journeys={journeys}
          onStoryClick={onStoryClick}
          name={name}
          analyticsContext={analyticsContext}
          fullWidthImage
        />
      </div>
      {initiativesTitle}
      {initiativesList}
      {issuerDetails}
    </section>
  )
}

HowAchievedSection.defaultProps = {
  initiatives: [],
  children: null,
  issuer: null
}

export default HowAchievedSection
